function setLangNaturesComponent(lang,opts) {
    var nature = opts.shopNatureName;
    var language= opts.language;
    
    if (nature !== "RealEstate") return lang;

    if (nature === "RealEstate") {
        if (language === 'English') {
            lang.navi.wishList = "Favors";
            lang.navi.orders = "Checkouts";
            lang.navi.cart = "Saved Favors";
            lang.cart.submitOrder = "Checkout Request";
            lang.navi.listing = "Properties";
            lang.order.detail = "Checkout Request Detail";  
            lang.common.addToCart="Add To Favors";
            lang.common.addToWishList="Keep Locally";
            lang.itemDetail.cart=lang.navi.cart;
            lang.order.orderNum="Request Number";
        } else {
            lang.navi.wishList = "喜好";
            lang.navi.orders = "我的預約";
            lang.navi.cart = "保存的喜好";
            lang.cart.submitOrder = "預約看樓";
            lang.navi.listing = "物業";
            lang.order.detail = "預約詳細資料"; 
            lang.common.addToCart="保存喜好";
            lang.common.addToWishList="暫存";
            lang.itemDetail.cart=lang.navi.cart;
            lang.order.orderNum="預約號碼";
        }
    }
    return lang;
};

export function setNatureComponents(lang, opts) {
    return setLangNaturesComponent(lang, opts);
}